import React from 'react'
export default function BarChart({ className, style }) {
  return (
    <svg className={className} width="1em" height="1em" style={{ verticalAlign: '-0.125em', ...style }}
      viewBox="0 0 24 24" fill="none"
      stroke="currentColor" strokeWidth="1.8"
      strokeLinecap="round" strokeLinejoin="round">
      <path d="M6 20v-6" />
      <path d="M12 20V8" />
      <path d="M18 20v-9" />
    </svg>
  )
}
